<template>
  <div>
    <v-app-bar fixed dense height="80px" class="main-header desktop-header">
      <div
        :class="
          menuClass ? menuClass + ' header-container' : 'header-container'
        "
      >
        <router-link to="/" class="logo">
          <img :src="logo" alt="" />
        </router-link>

        <nav v-if="isLogined" class="main-menu">
          <router-link to="/home" v-slot="{ href, navigate, isActive }" custom>
            <a class="nav-item" :href="href" @click="navigate">
              <v-icon :class="isActive ? 'secondary--text' : 'primary--text'"
                >fa-home</v-icon
              >
              <span
                :class="
                  isActive ? 'secondary--text text' : 'primary--text text'
                "
                >Hjem</span
              >
            </a>
          </router-link>

          <router-link
            to="/forbruk"
            v-slot="{ href, navigate, isActive }"
            custom
          >
            <a class="nav-item" :href="href" @click="navigate">
              <v-icon :class="isActive ? 'secondary--text' : 'primary--text'"
                >fa-chart-bar</v-icon
              >
              <span
                :class="
                  isActive ? 'secondary--text text' : 'primary--text text'
                "
                >Forbruk</span
              >
            </a>
          </router-link>

          <router-link
            to="/faktura"
            v-slot="{ href, navigate, isActive }"
            custom
          >
            <a class="nav-item" :href="href" @click="navigate">
              <v-icon :class="isActive ? 'secondary--text' : 'primary--text'"
                >fa-file</v-icon
              >
              <span
                :class="
                  isActive ? 'secondary--text text' : 'primary--text text'
                "
                >Faktura</span
              >
            </a>
          </router-link>

          <router-link
            to="/meldinger"
            v-slot="{ href, navigate, isActive }"
            custom
          >
            <a class="nav-item" :href="href" @click="navigate">
              <v-icon :class="isActive ? 'secondary--text' : 'primary--text'"
                >fa-bell</v-icon
              >
              <span
                :class="
                  isActive ? 'secondary--text text' : 'primary--text text'
                "
                >Meldinger</span
              >
            </a>
          </router-link>

          <!-- <router-link
            to="/profil"
            v-slot="{ href, navigate, isActive }"
            custom
          >
            <a class="nav-item" :href="href" @click="navigate">
              <v-icon :class="isActive ? 'secondary--text' : 'primary--text'"
                >fa-user</v-icon
              >
              <span
                :class="
                  isActive ? 'secondary--text text' : 'primary--text text'
                "
                >Profil</span
              >
            </a>
          </router-link> -->
        </nav>
      </div>

      <v-menu bottom min-width="245px" rounded offset-y>
        <template v-slot:activator="{ on }">
          <v-btn class="menu-btn" icon x-large v-on="on">
            <v-avatar color="primary" size="48">
              <span class="white--text headline">{{ initials }}</span>
            </v-avatar>
          </v-btn>
        </template>
        <v-card>
          <v-list-item-content class="justify-center">
            <div class="mx-auto text-center">
              <v-avatar color="primary" class="mb-4">
                <span class="white--text headline">{{ initials }}</span>
              </v-avatar>
              <h3>{{ name }}</h3>
              <p class="caption mt-1">
                {{ email }}
              </p>
              <v-divider class="my-3"></v-divider>
              <div class="options">
                <v-btn @click="goToLink('#/profil')" depressed rounded text>
                  <v-icon class="icon">fa-user</v-icon>
                  <span>PROFIL</span>
                </v-btn>
                <div class="divider"></div>
                <v-btn @click="signOut" depressed rounded text>
                  <v-icon class="icon">fa-sign-out-alt</v-icon>
                  <span>LOGG UT</span>
                </v-btn>
              </div>
            </div>
          </v-list-item-content>
        </v-card>
      </v-menu>
    </v-app-bar>

    <v-app-bar
      :bottom="true"
      fixed
      dense
      height="80px"
      class="main-header mobile-header"
    >
      <nav
        v-if="isLogined"
        :class="menuClass ? menuClass + ' main-menu' : 'main-menu'"
      >
        <router-link to="/home" v-slot="{ href, navigate, isActive }" custom>
          <a class="nav-item mobile" :href="href" @click="navigate">
            <v-icon :class="isActive ? 'secondary--text' : 'primary--text'"
              >fa-home</v-icon
            >
            <span :class="isActive ? 'secondary--text' : 'primary--text'"
              >Hjem</span
            >
          </a>
        </router-link>

        <router-link to="/forbruk" v-slot="{ href, navigate, isActive }" custom>
          <a class="nav-item mobile" :href="href" @click="navigate">
            <v-icon :class="isActive ? 'secondary--text' : 'primary--text'"
              >fa-chart-bar</v-icon
            >
            <span :class="isActive ? 'secondary--text' : 'primary--text'"
              >Forbruk</span
            >
          </a>
        </router-link>

        <router-link to="/faktura" v-slot="{ href, navigate, isActive }" custom>
          <a class="nav-item mobile" :href="href" @click="navigate">
            <v-icon :class="isActive ? 'secondary--text' : 'primary--text'"
              >fa-file</v-icon
            >
            <span :class="isActive ? 'secondary--text' : 'primary--text'"
              >Faktura</span
            >
          </a>
        </router-link>

        <router-link
          to="/meldinger"
          v-slot="{ href, navigate, isActive }"
          custom
        >
          <a class="nav-item mobile" :href="href" @click="navigate">
            <v-icon :class="isActive ? 'secondary--text' : 'primary--text'"
              >fa-bell</v-icon
            >
            <span :class="isActive ? 'secondary--text' : 'primary--text'"
              >Meldinger</span
            >
          </a>
        </router-link>

        <!-- <router-link to="/profil" v-slot="{ href, navigate, isActive }" custom>
          <a class="nav-item" :href="href" @click="navigate">
            <v-icon :class="isActive ? 'secondary--text' : 'primary--text'"
              >fa-user</v-icon
            >
          </a>
        </router-link> -->
      </nav>
    </v-app-bar>
  </div>
</template>

<script>
import {
  products,
  accountingPoints,
  account,
  customer,
} from '../../api/common';

import { mapMutations } from 'vuex';
import './Header.scss';

const getTenant = `*[_type == "config"]{
				logo{logo{asset->{url}}},
				colors
			}`;

export default {
  name: 'Header',
  components: {},
  props: ['isLogined'],

  data() {
    return {
      isActive: false,
      isMobile: false,
      logo: '',
      menuClass: '',
      email: '',
      name: '',
      initials: '',
    };
  },

  watch: {
    name(val) {
      let fullName = '',
        initials = '';

      if (val.indexOf(' ') != -1) {
        fullName = val.split(' ');
        initials = fullName.shift().charAt(0) + fullName.pop().charAt(0);
      } else {
        fullName = val;
        initials = fullName.shift().charAt(0);
      }

      this.initials = initials.toUpperCase();
    },
  },
  async created() {
    this.fetchTenant();
  },
  mounted() {
    if (window.innerWidth < 768) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }

    this.getContracts();
    this.getProducts();
    this.getCustomer();
    this.getAccount();
  },

  methods: {
    async fetchTenant() {
      await this.$sanity.fetch(getTenant).then(
        (tenant) => {
          this.$vuetify.theme.themes.light.primary = tenant[0].colors.primary;
          this.$vuetify.theme.themes.light.secondary =
            tenant[0].colors.secondary;
          this.logo = tenant[0].logo.logo.asset.url;
        },
        (error) => {
          this.error = error;
        }
      );
    },
    ...mapMutations(['openMenu']),

    goToLink(route) {
      let tmp = document.createElement('a');
      tmp.href = route;
      tmp.click();
    },

    signOut() {
      this.$AuthService.logout();
    },

    getCustomer() {
      return new Promise((resolve, reject) => {
        customer()
          .then((res) => {
            if (res.data) {
              if (res.data.Name) {
                this.name = res.data.Name;
              } else {
                this.name = res.data.GivenName + ' ' + res.data.FamilyName;
              }

              this.$store.commit('setUser', res.data);

              if (res.data.Guid) {
                this.$store.commit('setGUID', res.data.Guid);
              }
            }
          })
          .catch((error) => {
            console.log(error);

            reject(error);
          });
      });
    },

    getAccount() {
      return new Promise((resolve, reject) => {
        account()
          .then((res) => {
            if (res.data) {
              let account = res.data.Accounts[0];

              this.$store.commit('setAccount', account);

              account.Communication.forEach((item) => {
                item.Channel === 'Email' ? (this.email = item.Value) : '';
              });
            }
          })
          .catch((error) => {
            console.log(error);

            reject(error);
          });
      });
    },

    getContracts() {
      return new Promise((resolve, reject) => {
        accountingPoints()
          .then((res) => {
            if (res.data) {
              let filteredContracts = res.data.AccountingPoints.filter(
                (item) => item.Status === 'Active' || item.Status === 'Pending'
              );

              this.$store.commit('setContracts', filteredContracts);
            }
          })
          .catch((error) => {
            console.log(error);

            reject(error);
          });
      });
    },

    getProducts() {
      return new Promise((resolve, reject) => {
        products()
          .then((res) => {
            if (res.data) {
              let products = res.data.products.filter(
                  (item) => item.tags.indexOf('minside') !== -1
                ),
                primary = products.filter(
                  (item) => item.primaryProduct === true
                ),
                secondary = products.filter(
                  (item) => item.primaryProduct === false
                );
              this.$store.commit('setProducts', products);
              this.$store.commit('setPrimaryProducts', primary);
              this.$store.commit('setSecondaryProducts', secondary);
            }
          })
          .catch((error) => {
            console.log(error);

            reject(error);
          });
      });
    },
  },
};
</script>
